<template>
    <div style="height: 100vh;width: 250px">
        <div class="sidebar">
            <el-menu
                    class="sidebar-el-menu"
                    :default-active="onRoutes"
                    :collapse="collapse"
                    :default-openeds="defaultOpeneds"
                    text-color="black"
                    active-text-color="#20a0ff"
                    unique-opened
                    router
            >
                <template v-for="item in items">
                    <template v-if="item.subs">
                        <el-submenu :index="item.index" :key="item.index">
                            <template slot="title">
                                <i :class="item.icon"></i>
                                <span slot="title">{{ item.title }}</span>
                            </template>
                            <template v-for="subItem in item.subs">
                                <el-submenu
                                        v-if="subItem.subs"
                                        :index="subItem.index"
                                        :key="subItem.index"
                                >
                                    <template slot="title">{{ subItem.title }}</template>
                                    <el-menu-item
                                            v-for="(threeItem,i) in subItem.subs"
                                            :key="i"
                                            :index="threeItem.index"
                                    >{{ threeItem.title }}</el-menu-item>
                                </el-submenu>
                                <el-menu-item
                                        v-else
                                        :index="subItem.index"
                                        :key="subItem.index"
                                >{{ subItem.title }}</el-menu-item>
                            </template>
                        </el-submenu>
                    </template>
                    <template v-else>
                        <el-menu-item :index="item.index" :key="item.index">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>
                        </el-menu-item>
                    </template>
                </template>
            </el-menu>
        </div>

    </div>
</template>

<script>
    import bus from "../../../components/common/bus";

    export default {
        name: "left",
        data() {
            return {
                collapse: false,
                items: [
                    {
                        icon: '',
                        index:'personal',
                        title:'个人信息'
                    },
                    {
                        index:'finance',
                        title:'财务管理',
                        subs:[
                            {
                                index:'rechargeRecord_gr',
                                title:'充值记录'
                            },
                            {
                                index:'billRecord_gr',
                                title:'计费记录'
                            },
                            {
                                index: 'refundRecord_gr',
                                title:'退款记录'
                            }
                        ]
                    },
                    // {
                    //     index:'accounts',
                    //     title: '账号信息'
                    // },
                    // {
                    //     index:'seal',
                    //     title:'印章管理'
                    // },
                    // {
                    //     index:'aboutUs',
                    //     title: '关于我们'
                    // },

                ],
                defaultOpeneds: []  // 存储需要默认展开的子菜单index
            };
        },
        computed: {
            onRoutes() {
                return this.$route.path.replace('/', '');
            }
        },
        created() {
            // 监听路由变化，动态更新展开的子菜单
            this.$watch('$route', (to) => {
                this.updateOpenedSubmenus(to.path.replace('/', ''));
            }, { immediate: true });  // 初始化时立即执行

            // 通过 Event Bus 进行组件间通信，来折叠侧边栏
            bus.$on('collapse', msg => {
                this.collapse = msg;
                bus.$emit('collapse-content', msg);
            });
        },
        methods: {
            // 查找当前激活项所在的所有父级子菜单
            updateOpenedSubmenus(activeIndex) {
                const openedIndices = [];

                // 递归查找激活项的父级
                const findParent = (items, targetIndex) => {
                    for (const item of items) {
                        // 如果是子菜单
                        if (item.subs) {
                            // 检查子菜单中是否包含激活项
                            const hasActive = item.subs.some(sub =>
                                sub.index === targetIndex ||
                                (sub.subs && sub.subs.some(three => three.index === targetIndex))
                            );

                            if (hasActive) {
                                openedIndices.push(item.index);
                                // 如果有三级菜单，继续检查二级菜单
                                for (const sub of item.subs) {
                                    if (sub.subs && sub.subs.some(three => three.index === targetIndex)) {
                                        openedIndices.push(sub.index);
                                        return true; // 找到后退出
                                    }
                                }
                                return true; // 找到后退出
                            }

                            // 递归检查更深层级
                            if (findParent(item.subs, targetIndex)) {
                                return true;
                            }
                        }
                    }
                    return false;
                };

                findParent(this.items, activeIndex);
                this.defaultOpeneds = openedIndices;
            }
        }
    }
</script>

<style scoped>
    ::v-deep .el-menu{
        width: 250px;
        height: 100%;
    }
    .sidebar {
        display: block;
        position: absolute;
        left: 0;
        top: 7vh;
        bottom: 0;
        z-index: 10;

    }
    .sidebar::-webkit-scrollbar {
        width: 0;
    }
    .sidebar-el-menu:not(.el-menu--collapse) {
        width: 250px;
    }
    .sidebar > ul {
        height: 100%;
    }

</style>
